import {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";

export default function UserDisplayName(props) {

  const [context, setContext] = useContext(AppContext);
  const [user, setUser] = useState();
  const [admin, setAdmin] = useState(props.admin);

  useEffect(() => {
    if (!context?.sessionUser) {
      return;
    }
    if (admin) {
      setUser(context.sessionUser?.adminUser || context.sessionUser);
    } else {
      setUser(context.sessionUser);
    }
  }, [context?.sessionUser]);

  return (
    <>
      <div style={{
        width: '120px',
        overflow: 'hidden',
        paddingTop: '12px',
        height:'40px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        lineHeight:'0.9rem'
      }}>
        {user?.firstName} {user?.lastName}
      </div>
    </>
  )
}